import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import { clearStorage } from '@/utils/storage';
import user from './modules/user';
import dataMonitor from './modules/dataMonitor';
import notification from './modules/notification';
import message from './modules/message';

Vue.use(Vuex);
const initialState = {
  token: '',
  menuVisible: false,
  messageListVisible: false,
  noticeVisible: false,
  rechargeVisible: false,
  rechargeType: '0',
  rechargeDetail: {},
};

const store = new Vuex.Store({
  state: {
    lang: 'zh-CN',
    windowSize: {
      height: 1920,
      width: 1080,
    },
    ...initialState,
  },
  mutations: {
    updateState(state, payload) {
      Object.assign(state, payload);
    },
    clearSession(state) {
      clearStorage();
      Object.assign(state, {
        ...initialState,
      });
      store.commit('user/clearState');
      store.commit('dataMonitor/clearState');
    },
  },
  modules: {
    user,
    dataMonitor,
    notification,
    message,
  },
  plugins: [createPersistedState({ storage: window.sessionStorage })],
});

export default store;
